import React from "react";

const actions = ["lihat", "tambah", "edit", "hapus"];

const actionMap = {
  lihat: "view",
  tambah: "add",
  edit: "edit",
  hapus: "delete",
};

const moduleMap = {
  AdminData: "Data Admin",
  EmployeeData: "Data Karyawan",
  PartnerData: "Data Mitra",
  CommissionData: "Data Komisi",
  CassavaTransactions: "Transaksi Singkong",
  CassavaVerification: "Verifikasi Singkong",
  AccessManagement: "Manajemen Akses",
  UserSetup: "User Setup",
};

const AccessTable = ({ access = {}, onChange }) => {
  const handleAllChange = (moduleKey, checked) => {
    actions.forEach((action) => {
      onChange(moduleKey, actionMap[action], checked);
    });
  };

  return (
    <div className="text-sm border border-gray-200 rounded-lg shadow">
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white">
          <thead className="text-white bg-green-700">
            <tr>
              <th className="px-4 py-2 text-left">Modul</th>
              {actions.map((action) => (
                <th key={action} className="px-4 py-2 capitalize">
                  {action}
                </th>
              ))}
              <th className="px-4 py-2">Semua</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(moduleMap)
              .filter(([_, label]) => label !== "Manajemen Akses")
              .map(([moduleKey, label]) => {
                const currentAccess = access?.[moduleKey] || {};
                const allChecked = actions.every(
                  (action) => currentAccess[actionMap[action]]
                );

                return (
                  <tr key={moduleKey} className="border-t">
                    <td className="px-4 py-2 font-medium">{label}</td>
                    {actions.map((action) => (
                      <td key={action} className="px-4 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={!!currentAccess[actionMap[action]]}
                          onChange={(e) =>
                            onChange(
                              moduleKey,
                              actionMap[action],
                              e.target.checked
                            )
                          }
                        />
                      </td>
                    ))}
                    <td className="px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        onChange={(e) =>
                          handleAllChange(moduleKey, e.target.checked)
                        }
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccessTable;
